import axios from 'axios';
import config from '../config/config';



// Axios instance oluştur
const api = axios.create({
  baseURL: `${config.backendUrl}`,
  timeout: 30000, // 30 saniye timeout (stok işlemleri için)
  headers: {
    'Content-Type': 'application/json',
  },
});

const getActiveToken = () => {
  return localStorage.getItem('jansoft-token') || sessionStorage.getItem('jansoft-token') || null;
};

const getActiveStorage = () => {
  if (localStorage.getItem('jansoft-token')) return localStorage;
  if (sessionStorage.getItem('jansoft-token')) return sessionStorage;
  return localStorage;
};

// Request interceptor - token ekle
api.interceptors.request.use(
  (config) => {
    const token = getActiveToken();

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

const redirectToLogin = () => {
  // Public route kontrolü - public route'larda redirect yapma
  if (isPublicRoute()) {
    return; // Public route'larda redirect yapma
  }
  
  localStorage.removeItem('jansoft-token');
  localStorage.removeItem('user');
  sessionStorage.removeItem('jansoft-token');
  sessionStorage.removeItem('user');
  window.location.href = '/login';
};

const isAuthLoginRequest = (config) => {
  if (!config) return false;
  const url = config.url || '';
  return url.includes('/api/auth/login');
};

const isPublicRequest = (config) => {
  if (!config) return false;
  const url = config.url || '';
  return url.includes('/api/public/');
};

const isPublicRoute = () => {
  const publicRoutes = ['/pastel', '/cari/', '/login'];
  const currentPath = window.location.pathname;
  return publicRoutes.some(route => {
    if (route === '/cari/') {
      return currentPath.startsWith('/cari/');
    }
    return currentPath === route || currentPath.startsWith(route);
  });
};

// Response interceptor - hata yönetimi ve retry logic + otomatik refresh
api.interceptors.response.use(
  (response) => {
    return response;
  },
  async (error) => {
    // Network hatası durumunda otomatik retry
    if (error.code === 'ERR_NETWORK' || error.message.includes('Network Error')) {
      console.log('🔄 Bağlantı hatası, 3 saniye sonra yeniden deneniyor...');
      await new Promise(resolve => setTimeout(resolve, 3000));
      
      try {
        // Orijinal isteği tekrar dene
        const originalRequest = error.config;
        return api.request(originalRequest);
      } catch (retryError) {
        console.error('❌ Retry başarısız:', retryError);
      }
    }

    if (error.response?.status === 401) {
      const originalRequest = error.config || {};
      const reqUrl = String(originalRequest.url || '');
      const errCode = String(error.response?.data?.code || '');
      const errMsg = String(error.response?.data?.message || '');

      // Public route kontrolü - eğer public route'daysak hiçbir şey yapma
      if (isAuthLoginRequest(originalRequest) || isPublicRequest(originalRequest) || isPublicRoute()) {
        return Promise.reject(error);
      }

      // Turmob/efatura upstream hataları Jansoft oturumu değildir
      if (
        errCode.startsWith('TURMOB_')
        || /turmob/i.test(errMsg)
        || /\/efatura\//i.test(reqUrl)
      ) {
        return Promise.reject(error);
      }
      
      if (originalRequest && !originalRequest._retry) {
        originalRequest._retry = true;
        try {
          const currentToken = getActiveToken();
          if (!currentToken) {
            redirectToLogin();
            return Promise.reject(error);
          }
          const refreshResponse = await axios.post(`${config.backendUrl}/api/auth/refresh`, { token: currentToken });
          const newToken = refreshResponse.data?.token;
          if (!newToken) throw new Error('Refresh response missing token');

          const storage = getActiveStorage();
          storage.setItem('jansoft-token', newToken);

          // Update header and retry original request
          originalRequest.headers = originalRequest.headers || {};
          originalRequest.headers.Authorization = `Bearer ${newToken}`;
          return api.request(originalRequest);
        } catch (refreshErr) {
          redirectToLogin();
        }
      } else {
        redirectToLogin();
      }
    }
    
    return Promise.reject(error);
  }
);

export default api;
